<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="end" align="middle">
        <span class="px-10">优惠码</span>
        <el-input
            size="small"
            v-model="listQuery.code"
            placeholder="请输入优惠码"
            style="width: 200px"
            class="filter-item"
            clearable
        />
        <span class="px-10">用户id</span>
        <el-input
          size="small"
          v-model="listQuery.user_id"
          placeholder="请输入用户ID"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <span class="px-10">UUID</span>
        <el-input
          size="small"
          v-model="listQuery.uuid"
          placeholder="请输入uuid"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <span class="px-10">用户名</span>
        <el-input
          size="small"
          v-model="listQuery.username"
          placeholder="请输入用户名称"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          size="small"
          v-model="listQuery.last_name"
          placeholder="请输入姓"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          size="small"
          v-model="listQuery.first_name"
          placeholder="请输入名"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <span class="px-10">状态</span>
        <el-select
          size="small"
          v-model="listQuery.status"
          placeholder="状态"
          clearable
          style="width: 200px"
          class="filter-item"
        >
          <el-option label="已过期" value="expired" />
          <el-option label="已使用" value="used" />
          <el-option label="未使用" value="not_use" />
        </el-select>
        <el-button
          size="small"
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >搜索</el-button
        >
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="兑换码 ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.coupon_id }}
        </template>
      </el-table-column>
      <el-table-column label="优惠码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.code ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="折扣码标题" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.title_cn ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="积分兑换类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ value_type(scope.row.value_type) ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="用户ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.username || '' }}
        </template>
      </el-table-column>
      <el-table-column label="UUID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.last_name }}
        </template>
      </el-table-column>
      <el-table-column label="使用时间从" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.start_at ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="到" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_at == '-1' ? '无限制' : scope.row.end_at ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="优惠码类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ value_type(scope.row.value_type) ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="兑换码价值" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.value ?? '-' }}
        </template>
      </el-table-column>

      <el-table-column label="使用积分" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.exchange_value }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'used'" type="success">{{
            scope.row.status_show
          }}</el-tag>
          <el-tag v-else-if="scope.row.status === 'expired'" type="danger"
            >{{ scope.row.status_show }}
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'not_use'" type="warning"
            >{{ scope.row.status_show }}
          </el-tag>
          <el-tag v-else type="info">{{ scope.row.status_show }} </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="warning"   @click="edit(scope.row)">
            修改
          </el-button>
          <el-button   type="primary" @click="pass(scope.row.id)">
            兑换详情
          </el-button>
          <el-button   type="primary" @click="pass(scope.row.id)">
            下架
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        username: '',
        exchange_type: '',
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  computed: {
    value_type() {
      return (val) => {
        switch (val) {
          case 'fixed_amount':
            return '固定折扣'
          case 'percentage':
            return '百分比折扣'
        }
      }
    },
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/coupon/exchangeLogs',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    add(val) {
      this.$router.push('/operation/edit')
    },
    createuser() {
      this.$router.push('/USER/createuser')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
